export enum HouseDetailsSteps {
  houseAge = 'house-age',
  houseType = 'house-type',
}
